import * as Yup from 'yup';
import '@dfl/yup-validations';
import { IProduct } from '../interfaces/IProduct';

export const productRelatedSchema = Yup.object().shape({
  related: Yup.array()
    .of(Yup.string())
    .transform((items) => items?.map((item: IProduct) => item?._id || item)),
});
